import debug from 'debug';

const log = debug('app:videoUtils');

const downloadVideo = (url: string, name: string) => {
  try {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.download = name;
    a.click();
    document.body.removeChild(a);
  } catch (error) {
    log(error);
  }
};

// Function to handle multiple downloads with delays to avoid browser blocking
const downloadMultipleVideos = (
  downloads: Array<{ url: string; name: string }>,
) => {
  console.log(
    `Starting download of ${downloads.length} files:`,
    downloads.map((d) => d.name),
  );

  downloads.forEach(({ url, name }, index) => {
    setTimeout(() => {
      console.log(`Downloading file ${index + 1}/${downloads.length}: ${name}`);
      downloadVideo(url, name);
    }, index * 500); // Stagger downloads by 500ms each
  });
};

/**
 * Formats duration in seconds to a readable time string
 * @param seconds - Duration in seconds
 * @returns Formatted string like "5:23" or "1:05:23"
 */
export const formatDuration = (seconds: number | undefined): string => {
  if (typeof seconds !== 'number') return '0:00';
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return hours > 0
    ? `${hours}:${minutes
        .toString()
        .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
    : `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

/**
 * Extracts YouTube thumbnail URL from a YouTube video URL
 * @param url - YouTube video URL
 * @returns Thumbnail URL or null if not a valid YouTube URL
 */
export const getYouTubeThumbnail = (url: string | undefined): string | null => {
  if (!url) return null;

  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/,
    /youtube\.com\/embed\/([^&\n?#]+)/,
  ];

  // eslint-disable-next-line no-restricted-syntax
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      // Use mqdefault for medium quality thumbnail (320x180)
      return `https://img.youtube.com/vi/${match[1]}/mqdefault.jpg`;
    }
  }
  return null;
};

export { downloadVideo, downloadMultipleVideos };
export default downloadVideo;
